import { render, staticRenderFns } from "./ScoreComponent.vue?vue&type=template&id=675884e5&"
import script from "./ScoreComponent.vue?vue&type=script&lang=js&"
export * from "./ScoreComponent.vue?vue&type=script&lang=js&"
import style0 from "./ScoreComponent.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports